/**
 * Created by wuyanbin on 2019/10/28
 */
import React, { Component } from 'react';
class YearArea extends Component {
    constructor() {
        super(...arguments);
        this.handleYearChange = (type) => {
            this.props.handleYearChange(type);
        };
    }
    render() {
        const { currentYear } = this.props;
        return (<div className="ant-calendar-header">
        <div style={{ position: 'relative' }}>
          <a className="ant-calendar-prev-year-btn" title="上一年" onClick={() => {
            this.handleYearChange('before');
        }}/>
          <span className="ant-calendar-ym-select">{currentYear}</span>
          <a className="ant-calendar-next-year-btn" title="下一年" onClick={() => {
            this.handleYearChange('after');
        }}/>
        </div>
      </div>);
    }
}
export default YearArea;
